import I18nTranslations from '../i18n/translations'

export default new I18nTranslations({translationContext: 'phoenix'})
